import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Grid, Typography, Link as MuiLink } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// Helper function to convert text into a URL-friendly "slug"
const slugify = (text) => {
  // Example: "Collection Family" -> "collection-family"
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  return text.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

const MegaMenu = ({ content, basePath }) => {
  if (!content) return null;

  const { featured, links } = content;

  const linkStyle = {
    display: 'block',
    textDecoration: 'none',
    color: '#5c6c68',
    fontFamily: "'Lato', sans-serif",
    padding: '6px 0',
    fontSize: '0.95rem',
    '&:hover': {
      color: '#D4A259',
    },
  };

  return (
    <Box sx={{ p: 4, backgroundColor: '#FCF9F3', minWidth: '600px', display: 'flex', borderRadius: '8px' }}>
      <Grid container spacing={4}>
        {/* Featured Section */}
        <Grid item xs={5}>
          <Box
            component={Link}
            to={basePath} // The featured item links to the base path, e.g., /trips
            sx={{
              display: 'block',
              position: 'relative',
              overflow: 'hidden',
              borderRadius: '4px',
              height: '100%',
              textDecoration: 'none',
              '& .overlay': {
                opacity: 0,
                transition: 'opacity 0.3s ease',
              },
              '&:hover .overlay': {
                opacity: 1,
              },
              '&:hover img': {
                transform: 'scale(1.05)',
              }
            }}
          >
            <img
              src={featured.image}
              alt={featured.key}
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.3s ease' }}
            />
            <Box
              className="overlay"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                p: 2,
              }}
            >
              <Typography variant="h6" component="div" sx={{ fontFamily:'"Cormorant Garamond", "Georgia", serif' }}>
                {featured.key}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <Typography variant="body2" sx={{ fontFamily: "'Lato', sans-serif" }}>View All</Typography>
                <ArrowForwardIcon sx={{ fontSize: '1rem', ml: 0.5 }} />
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* Links Section */}
        <Grid item xs={7}>
          <Grid container spacing={4}>
            {links.map((linkGroup) => (
              <Grid item xs={6} key={linkGroup.key}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontFamily: "'Lato', sans-serif",
                    fontWeight: 700,
                    color: '#2E3836',
                    marginBottom: 1,
                    borderBottom: '2px solid #D4A259',
                    paddingBottom: '4px',
                    display: 'inline-block'
                  }}
                >
                  {linkGroup.key}
                </Typography>
                <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
                  {linkGroup.items.map((item) => (
                    <li key={item}>
                      <MuiLink
                        component={Link}
                        // This is the crucial part: construct the correct URL
                        to={`${basePath}/${slugify(item)}`}
                        sx={linkStyle}
                      >
                        {item.split(' ').slice(1).join(' ')} {/* Removes prefix like "Collection " */}
                      </MuiLink>
                    </li>
                  ))}
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MegaMenu;